import { takeEvery, call, put, fork } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import {
    FETCH_CONNECTIONS,
    FETCH_CONNECTIONS_START,
    FETCH_CONNECTIONS_SUCCESS,
    FETCH_CONNECTIONS_FAIL,
    FETCH_PENDING_CONNECTIONS,
    FETCH_PENDING_CONNECTIONS_START,
    FETCH_PENDING_CONNECTIONS_SUCCESS,
    FETCH_PENDING_CONNECTIONS_FAIL
} from 'actions/ActionTypes';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

export function* fetchConnections(action) {
    const { displayName, start, limit } = action.payload;
    const DEFAULT_LIMIT = 12;

    try {
        yield put({
            type: FETCH_CONNECTIONS_START
        });

        const response = yield call(
            gcApi.get,
            `connection-service/connection/connections/pagination/${displayName}?start=${start}&limit=${limit ||
                DEFAULT_LIMIT}&displayMutedStatus=true`
        );

        yield put({
            type: FETCH_CONNECTIONS_SUCCESS,
            data: response.data.userConnections,
            connectionFullName: response.data.fullName,
            hasMoreToLoad: response.data.userConnections.length === (limit || DEFAULT_LIMIT),
            replace: start === 1
        });

        yield fork(fetchConnectionListProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_CONNECTIONS_FAIL
        });
    }
}

export function* fetchPendingConnections() {
    try {
        yield put({
            type: FETCH_PENDING_CONNECTIONS_START
        });

        const response = yield call(
            gcApi.get,
            'connection-service/connection/pending?mutualConnectionCountIncluded=true'
        );

        yield put({
            type: FETCH_PENDING_CONNECTIONS_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PENDING_CONNECTIONS_FAIL
        });
    }
}

/// section: fetching profile image and frame

/**
 * handle suggested connection list
 * @param {Object} responseData
 * @param {Object[]} responseData.userConnections
 * @param {number} responseData.userConnections[].userId
 */
function* fetchConnectionListProfileImageAndFrameSaga(responseData) {
    if (!responseData?.userConnections?.length) {
        return;
    }
    const userIds = responseData?.userConnections.map((item) => item.userId);
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

/// end section: fetching profile image and frame

export const connectionSagas = [
    takeEvery(FETCH_CONNECTIONS, fetchConnections),
    takeEvery(FETCH_PENDING_CONNECTIONS, fetchPendingConnections)
];
